import { Chip, Tooltip } from '@mui/material';

import type { Invoice } from '~/data/schemas/invoice';

type CreditStatus = Pick<Invoice, 'creditedInvoice' | 'keepOnFileOnly' | 'countsTowardSpend'>;

export const ON_FILE_ONLY_LABEL = 'On file only · already deducted';

const creditTargetLabel = (credit: Pick<Invoice, 'creditedInvoice'>): string =>
  credit.creditedInvoice ? 'Invoice credit' : 'Account credit';

const CreditStatusChip: React.FC<{ credit: CreditStatus }> = ({ credit }) => {
  if (credit.keepOnFileOnly) {
    return (
      <Tooltip title="Kept on file only because the amount was already deducted. It doesn't count toward spend.">
        <Chip label={ON_FILE_ONLY_LABEL} variant="outlined" />
      </Tooltip>
    );
  }
  const label = creditTargetLabel(credit);
  // An invoice credit stops counting once its invoice no longer counts toward spend.
  if (credit.countsTowardSpend === false) {
    return (
      <Tooltip title="The invoice this credit applies to no longer counts toward spend, so neither does the credit.">
        <Chip label={`${label} · not counting`} color="error" variant="outlined" />
      </Tooltip>
    );
  }
  return <Chip label={label} color="success" variant="outlined" />;
};

export default CreditStatusChip;
